export const SAVE_TRACKING_PREFERENCES = 'consent-manager/save-preferences';
export const OPEN_CONSENT_MODAL = 'consent-manager/open-modal';
